import { PlannerBase } from '../../planner_base';
import watch   from "redux-watch";
import isEqual from 'is-equal';
import { save }        from "apps/actions/common";
import {
  Global,
  LineSelectedSchedule,
  LineSelectedTask
} from '../model';
import PlannerControllerBase from './base';
import {
  PLANNER_CMD_CANCEL_DESTROY_SCHEDULE
} from 'apps/events';
export default class CommandsController extends PlannerControllerBase {
  constructor(tag){
    super(tag);
    this.customEvent(PLANNER_CMD_CANCEL_DESTROY_SCHEDULE, (e) => {this.onCommandCancelDestroySchedule(e) });
  }
  // のスケジュールの削除を元に戻すがクリックされた
  onCommandCancelDestroySchedule(e){
    App.store.dispatch(save(this.saveParams(e.detail)))
  }
  saveParams(detail){
    let payload = detail;
    payload['scope'] = Global.dataScopeLine(detail.line_id)
    return payload;
  }
}
